(function () {
  // ── Consent model: DELAYED OPT-OUT (company decision, 2026-07-24) ─────
  // Nothing fires while the visitor is undecided. Accept → granted.
  // Demonstrably ignoring the banner (scroll away / next page / grace
  // timer) → treated as granted, stored as 'implied' (distinct from
  // 'accepted' so our records stay honest about who actually clicked).
  // Reject / Customise-off → denied, honoured everywhere, cookies purged.
  // LIVE_TRACKING=false reverts every consent call to a no-op (staging).
  var LIVE_TRACKING = true;
  // ─────────────────────────────────────────────────────────────────────

  var COOKIE_NAME = 'cookie_consent';
  var COOKIE_DAYS = 365;

  function getConsent() {
    var m = document.cookie.match(/(?:^|;\s*)cookie_consent=([^;]*)/);
    return m ? m[1] : null;
  }

  function setConsent(value) {
    var d = new Date();
    d.setTime(d.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE_NAME + '=' + value + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  function grantGTMConsent() {
    if (!LIVE_TRACKING) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(function () {
      this.set('consent', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
      });
    });
    if (typeof gtag === 'function') {
      gtag('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
      });
    }
  }

  // ── Shopify Customer Privacy API ──────────────────────────────────────
  // The native Shopify channel pixels (Meta, TikTok, Pinterest, Snapchat)
  // obey Shopify's consent API, NOT our cookie — and only when regional
  // enforcement (Settings → Customer privacy, UK/EEA) is enabled. With it
  // on, pixels stay silent until this grants; we re-assert the stored
  // state on every page load so they stay in sync.
  function setShopifyConsent(analytics, marketing) {
    if (!LIVE_TRACKING) return;
    function apply() {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics:    analytics,
          marketing:    marketing,
          preferences:  analytics,
          sale_of_data: marketing
        }, function () {});
      } catch (e) {}
    }
    if (window.Shopify && window.Shopify.customerPrivacy) {
      apply();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (err) { if (!err) apply(); }
      );
    }
  }

  function showOverlay() {
    if (!document.body.classList.contains('ig-cb-d')) return;
    var overlay = document.createElement('div');
    overlay.id = 'cookie-overlay';
    document.body.appendChild(overlay);
    // Trigger fade-in on next frame so the CSS transition fires
    requestAnimationFrame(function () {
      overlay.style.background = 'rgba(0,0,0,0.10)';
    });
  }

  function hideOverlay() {
    var overlay = document.getElementById('cookie-overlay');
    if (!overlay) return;
    overlay.style.background = 'rgba(0,0,0,0)';
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 450);
  }

  // Called only when a choice has been made — removes the banner AND the
  // minimised chip for good; the consent cookie keeps both away next visit.
  function hideBanner() {
    var banner = document.getElementById('cookie-banner');
    if (!banner) return;
    banner.classList.remove('cookie-banner--visible');
    hideOverlay();
    hideChip();
    try { sessionStorage.removeItem('cookie_banner_seen'); } catch (e) {}
    setTimeout(function () {
      if (banner.parentNode) banner.parentNode.removeChild(banner);
      var chip = document.getElementById('cookie-chip');
      if (chip && chip.parentNode) chip.parentNode.removeChild(chip);
    }, 380);
  }

  // Wording test (Intelligems) — pure CSS label swaps, behaviour identical:
  //   ig-cb-b = same design as A, Reject reads "Accept Essentials Only"
  //   ig-cb-c = "Essentials Only" as ghost button, "Accept All" as the
  //             single filled button
  // Strip only the retired design-variant classes so the old D/none looks
  // can't leak in from stale Intelligems state.
  ['ig-cb-d', 'ig-cb-none'].forEach(function (c) {
    document.body.classList.remove(c);
  });

  // Preview mode: ?cb=none/b/c/d still works for manual testing
  var previewVariant = new URLSearchParams(window.location.search).get('cb');
  if (previewVariant) {
    document.body.classList.add('ig-cb-' + previewVariant);
  }

  // Variant 1 — no banner, auto-grant in live mode (preview only now)
  if (document.body.classList.contains('ig-cb-none')) {
    if (LIVE_TRACKING) grantGTMConsent();
    return;
  }

  // ── Consent state routing ─────────────────────────────────────────────
  // cookie_consent: null       = undecided — nothing fires yet (Consent
  //                              Mode defaults are denied in theme.liquid)
  //                 'implied'  = ignored the banner — collection runs as
  //                              granted; chip stays so they can object
  //                 'accepted' / 'declined' = explicit choice, final
  var state = getConsent();

  function readPrefs() {
    var analytics = true;
    var marketing = true;
    var m = document.cookie.match(/(?:^|;\s*)cookie_prefs=([^;]*)/);
    if (m) {
      try {
        var p = JSON.parse(decodeURIComponent(m[1]));
        analytics = !!p.a;
        marketing = !!p.m;
      } catch (e) {}
    }
    return { analytics: analytics, marketing: marketing };
  }

  // Delete tracking cookies for denied categories so a rejection actually
  // scrubs the device, not just future hits.
  function purgeTrackingCookies(analytics, marketing) {
    var patterns = [];
    if (analytics) patterns.push(/^(_ga|_gid|_gat)/);
    if (marketing) patterns.push(/^(_fbp|_fbc|_ttp|_tt_|_scid|_pin_)/);
    if (!patterns.length) return;
    var names = [];
    document.cookie.split(';').forEach(function (c) {
      var n = c.split('=')[0].trim();
      if (patterns.some(function (re) { return re.test(n); })) names.push(n);
    });
    var host = location.hostname;
    var apex = '.' + host.replace(/^www\./, '');
    names.forEach(function (n) {
      ['', host, apex].forEach(function (d) {
        document.cookie = n + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + (d ? '; domain=' + d : '');
      });
    });
  }

  // Re-assert the stored state to Shopify on every load so the native
  // pixels follow it once regional enforcement is on.
  if (state === 'accepted' || state === 'implied') {
    var storedPrefs = readPrefs();
    setShopifyConsent(storedPrefs.analytics, storedPrefs.marketing);
  } else if (state === 'declined') {
    setShopifyConsent(false, false);
  }

  // Explicit choices are final — no banner, no chip, ever again
  if ((state === 'accepted' || state === 'declined') && !previewVariant) return;

  // The "ignored" moment: scrolled away, moved to another page, or let the
  // grace timer lapse without choosing. Silence = collect: store 'implied'
  // and start normal collection. The chip stays available to object later.
  var IMPLIED_GRACE_MS = 12000;

  function impliedTrigger() {
    if (previewVariant || getConsent()) return; // explicit choice wins; QA never writes
    setConsent('implied');
    grantGTMConsent();
    setShopifyConsent(true, true);
    if (window.__loadHeatmap) window.__loadHeatmap();
  }

  // ── Minimise-on-scroll ────────────────────────────────────────────────
  // First page of the session: the banner opens fully (1.5s delay as
  // before). Scrolling away folds it into the corner chip; on later pages
  // (same session, still no choice) it starts folded. The chip re-expands
  // the full banner at any time until a choice is made.
  var SCROLL_THRESHOLD = 120; // px of scroll before the banner folds away
  var scrollAnchor = null;    // scroll position when the banner opened

  var seenBefore = false;
  try { seenBefore = sessionStorage.getItem('cookie_banner_seen') === '1'; } catch (e) {}

  function showChip() {
    var chip = document.getElementById('cookie-chip');
    if (!chip) return;
    chip.hidden = false;
    requestAnimationFrame(function () { chip.classList.add('cookie-chip--visible'); });
  }

  function hideChip() {
    var chip = document.getElementById('cookie-chip');
    if (!chip || chip.hidden) return;
    chip.classList.remove('cookie-chip--visible');
    setTimeout(function () { chip.hidden = true; }, 300);
  }

  function openBanner() {
    var banner = document.getElementById('cookie-banner');
    if (!banner) return;
    hideChip();
    banner.classList.add('cookie-banner--visible');
    showOverlay();
    scrollAnchor = window.pageYOffset;
    try { sessionStorage.setItem('cookie_banner_seen', '1'); } catch (e) {}
  }

  function minimizeBanner() {
    var banner = document.getElementById('cookie-banner');
    if (!banner || !banner.classList.contains('cookie-banner--visible')) return;
    // Never fold away mid-interaction while the Customise panel is open
    if (banner.classList.contains('cookie-banner--expanded')) return;
    banner.classList.remove('cookie-banner--visible');
    hideOverlay();
    scrollAnchor = null;
    showChip();
    impliedTrigger(); // scrolling away from the banner counts as ignoring it
  }

  window.addEventListener('scroll', function () {
    if (scrollAnchor === null) return;
    if (Math.abs(window.pageYOffset - scrollAnchor) > SCROLL_THRESHOLD) minimizeBanner();
  }, { passive: true });

  var chipBtn = document.getElementById('cookie-chip');
  if (chipBtn) chipBtn.addEventListener('click', openBanner);

  if (previewVariant) {
    openBanner();
  } else if (state === 'implied') {
    // Already collecting; keep the chip on every page as the way to object
    showChip();
  } else if (seenBefore) {
    // Second page while still undecided — that's an "ignore"
    impliedTrigger();
    showChip();
  } else {
    setTimeout(openBanner, 1500);
    setTimeout(impliedTrigger, IMPLIED_GRACE_MS);
  }

  var acceptBtn    = document.getElementById('cookie-accept');
  var rejectBtn    = document.getElementById('cookie-reject');
  var customizeBtn = document.getElementById('cookie-customize');
  var savePrefsBtn = document.getElementById('cookie-save-prefs');

  // Accept all — grant everything, no granular prefs cookie needed
  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      setConsent('accepted');
      grantGTMConsent();
      setShopifyConsent(true, true);
      hideBanner();
    });
  }

  // Reject all — deny every non-essential category and scrub the device
  if (rejectBtn) {
    rejectBtn.addEventListener('click', function () {
      setConsent('declined');
      purgeTrackingCookies(true, true);
      if (LIVE_TRACKING && typeof gtag === 'function') {
        gtag('consent', 'update', {
          analytics_storage:  'denied',
          ad_storage:         'denied',
          ad_user_data:       'denied',
          ad_personalization: 'denied'
        });
      }
      setShopifyConsent(false, false);
      hideBanner();
    });
  }

  // Customise — toggle the preferences panel open/closed
  if (customizeBtn) {
    customizeBtn.addEventListener('click', function () {
      var banner = document.getElementById('cookie-banner');
      var panel  = document.getElementById('cookie-preferences');
      var isOpen = banner.classList.contains('cookie-banner--expanded');

      if (!isOpen) {
        // Show first so the transition has something to animate
        panel.style.display = 'flex';
        requestAnimationFrame(function () {
          banner.classList.add('cookie-banner--expanded');
        });
      } else {
        // Animate closed, then remove from layout.
        // Filter to max-height (the slower 0.38s transition) so we only
        // fire once and never hide the panel mid-animation.
        banner.classList.remove('cookie-banner--expanded');
        panel.addEventListener('transitionend', function hide(e) {
          if (e.propertyName !== 'max-height') return;
          panel.style.display = 'none';
          panel.removeEventListener('transitionend', hide);
        });
      }

      customizeBtn.setAttribute('aria-expanded', String(!isOpen));
      if (panel) panel.setAttribute('aria-hidden', String(isOpen));
    });
  }

  // Save preferences — apply granular consent and dismiss
  if (savePrefsBtn) {
    savePrefsBtn.addEventListener('click', function () {
      var analytics = document.getElementById('pref-analytics').checked;
      var marketing = document.getElementById('pref-marketing').checked;

      // Persist granular choices in a separate cookie
      var d = new Date();
      d.setTime(d.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
      var prefs = JSON.stringify({ a: analytics ? 1 : 0, m: marketing ? 1 : 0 });
      document.cookie = 'cookie_prefs=' + encodeURIComponent(prefs) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';

      setConsent('accepted');
      purgeTrackingCookies(!analytics, !marketing);

      // Fire GTM consent update with per-category states
      if (LIVE_TRACKING && typeof gtag === 'function') {
        gtag('consent', 'update', {
          analytics_storage:   analytics ? 'granted' : 'denied',
          ad_storage:          marketing ? 'granted' : 'denied',
          ad_user_data:        marketing ? 'granted' : 'denied',
          ad_personalization:  marketing ? 'granted' : 'denied'
        });
      }

      setShopifyConsent(analytics, marketing);
      hideBanner();
    });
  }
})();
